import React from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BackgroundPic from "./assets/sport.webp";
import Logo from "./assets/logo3.png";

function LandingPage() {
  const navigate = useNavigate();
  const theme = useTheme(); // استفاده از تم برای تنظیمات ریسپانسیو

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundImage: `url(${BackgroundPic})`, // لینک به تصویر پس‌زمینه
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        textAlign: "center",
        color: "#fff", // تغییر رنگ متن به سفید
        padding: "20px",
      }}
    >
      {/* لایه نیمه‌شفاف برای متن */}
      <Box
        sx={{
          backgroundColor: "rgba(0, 0, 0, 0.8)", // پس‌زمینه تیره با شفافیت
          borderRadius: "10px",
          padding: "30px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.7)", // سایه برای متن
          width: "90%",
          maxWidth: "600px",
          [theme.breakpoints.down("sm")]: {
            padding: "20px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={Logo}
            alt="Logo"
            style={{
              width: "300px",
              height: "auto",
              marginBottom: "20px",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          />
        </Box>
        <Typography
          variant="h3"
          component="h1"
          gutterBottom
          sx={{
            fontSize: "2rem", // اندازه فونت پایه
            [theme.breakpoints.down("sm")]: {
              fontSize: "1.5rem", // کوچک‌تر شدن فونت در دستگاه‌های کوچک
            },
          }}
        >
          فدراسیون ورزش های ناشنوایان
        </Typography>
        {/* <Typography
          variant="subtitle1"
          gutterBottom
          sx={{
            fontSize: "1rem",
            [theme.breakpoints.down("sm")]: {
              fontSize: "0.9rem",
            },
          }}
        >
          پلتفرمی هوشمند برای ارتباط ورزشکاران ناشنوا با فدراسیون
        </Typography> */}
        <Button
          variant="contained"
          color="primary"
          size="large"
          sx={{
            marginTop: 2,
            marginRight: 2,
            padding: "10px 20px",
            fontSize: "16px",
            fontWeight: "bold",
          }}
          onClick={() => navigate("/sign-up")}
        >
          ثبت نام
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="large"
          sx={{
            marginTop: 2,
            padding: "10px 20px",
            fontSize: "16px",
            fontWeight: "bold",
          }}
          onClick={() => navigate("/dashboard")}
        >
          ورود به سامانه
        </Button>
      </Box>
    </Box>
  );
}

export default LandingPage;
